import React from 'react'

const FixedDeposit = () => {
    const fixedDepositTerms = [
        'Minimum balance Rs. 1000 with effect from 10.07.2022',
        'Nomination compulsory; if the nominee is a minor, a guarantor must be competently appointed',
        'FD (Term Scheme) can be opened only for an individual; no joint account facility is available',
        'Minor cannot open an FD (Term Scheme) account',
        'Cash remittance is permitted up to Rs. 20,000/-; above that, only cheque or DD will be accepted',
        'Additional interest of 0.50% for senior citizens (aged 60 years and above) is available for deposits of Rs. 1 lakh and above',
        'After maturity, payment on irregular accounts will be made after deducting a penalty amount (up to the interest earned). No deduction from principal',
        'All interest payments are subject to TDS deduction as per Government instructions',
        'Maturity / Pre-closure amount will be paid through account payee cheque only'
    ];

    const tableData = [
        {
            month: '48 Month',
            general: '8%',
            srCtz: '8.25%'
        },
        {
            month: '60 Month',
            general: '8.25%',
            srCtz: '8.50%'
        },
        {
            month: '72 Month',
            general: '8.50%',
            srCtz: '8.75%'
        },
        {
            month: '96 Month',
            general: '8.75%',
            srCtz: '9.00%'
        },
        {
            month: '120 Month',
            general: '9.25%',
            srCtz: '9.50%'
        },
    ]
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    What is an Annual Fixed Deposit?
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    An annual fixed deposit, or cumulative deposit, refers to a lump sum invested for a fixed term at a predetermined interest rate. At the end of the term, both the principal and interest are paid together. The interest earned throughout the period is compounded annually, meaning it is added to the principal each year.

                    Interest rates for fixed deposits are influenced by factors like government policies, economic conditions, and market liquidity. However, SAI SAMRIDDHI’s Fixed Deposit Scheme offers fixed interest rates, ensuring that your interest compounds yearly. Below is a sample of our annual deposit chart, highlighting the growth of your investment with compounded interest over time.

                    By following a robust financial plan and choosing reliable deposit schemes, you can achieve financial security and accomplish your life goals while making the most of your money.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Feature of Fixed Deposit
                </h2>

                <div className='border'>
                    <div className='flex flex-row'>
                        <div style={{ flex: 1 }} className='bg-blue-600 border flex items-center justify-center'>
                            <p className='font-bold text-white text-md text-center'>Tenure</p>
                        </div>
                        <div style={{ flex: 2 }} className='bg-blue-600 border'>
                            <div className='p-4'>
                                <p className='font-bold text-white text-md text-center'>Denomination</p>
                            </div>
                            <div className='flex'>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>General</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center '>Sr. Citizen</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        tableData.map((item) => (
                            <div className='flex '>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium  text-md text-center'>{item.month}</p>
                                </div>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium text-md text-center'>{item.general}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.srCtz}</p>
                                </div>
                            </div>
                        ))
                    }

                </div>

            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Conditions
                </h2>
                {fixedDepositTerms.map((point, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                        <span className="text-md text-gray-600">{point}</span>
                    </div>
                ))}
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Pre Closure Conditions:
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    If the customer opting for pre-closure of the fixed deposit before expiry, the interest will be revised to the corresponding interest rate fixed for the period where the date of the pre-closure date falls. An additional 2% will be deducted from this rate as a penalty.
                </p>
            </div>

        </div>
    )
}

export default FixedDeposit
